export const logAudit = (source, action, label, details = {}) => {
    try {
        const token = localStorage.getItem('authToken');
        if (!token) return;

        fetch('/api/audit/log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                source,
                action,
                label,
                details
            }),
            keepalive: true
        }).catch(() => {});
    } catch (_) {
        // Audit must never block the UI.
    }
};
